import styled from 'styled-components';
import { DARK_GREY_COLOR } from '../../config/colors';

const Wrapper = styled.div`
	// border: 1px solid #292929;
	font-size: 12px;
	.collateral-amount-container {
		padding: 12px 0px;
		position: relative;
		.btn-public {
			position: absolute;
			right: 15px;
			top: 6px;
			width: 120px;
			> button {
				border-color: #00f;
			}
		}
		.public-text {
			position: absolute;
			right: 15px;
			top: 6px;
			width: 170px;
			text-align: center;
			p {
				font-size: 15px;
				color: #288500;
				white-space: nowrap;
				margin: 0;
				line-height: 1;
			}
			.ant-btn {
				a {
					text-decoration: none;
				}
			}
			.copy-link {
				line-height: 1;
				font-size: 12px;
				color: #00f;
				text-decoration: underline;
				cursor: pointer;
				input {
					position: fixed;
					left: -999px;
					top: -999px;
				}
			}
		}
		.collateral-amount-container-description {
			display: flex;
			h3 {
				margin-right: 12px;
			}
			p {
				color: ${DARK_GREY_COLOR};
				font-size: 12px;
			}
			.link {
				text-decoration: underline;
				color: #00f;
				cursor: pointer;
			}
		}
		.collater-progressbar {
			width: 100%;
			position: relative;
			height: 45px;
			// background-color: ${DARK_GREY_COLOR};
			background-color: #333333;
			overflow: hidden;
			margin-top: 24px;
			border: 1px solid #E5E5E5;
			.others-amount {
				position: absolute;
				left: 0;
				top: 0;
				height: 45px;
				padding: 0;
				background-color: #F15A24;
			}
			.my-amount {
				position: absolute;
				top: 0;
				height: 45px;
				padding: 0;
				background-color: #00f;
			}
		}
		.tier-member,
		.lite-member,
		.holla-member {
			background-color: #FFFFFF;
			bottom: 0px;
			height: 60px;
			position: absolute;
			width: 2px;
		}
		.tier-member {
			left: ${(props) => `${props.tierMemberAmount}%`};
		}
		.lite-member {
			left: ${(props) => `${props.liteMemberAmount}%`};
		}
		.holla-member {
			left: ${(props) => `${props.hollaMemberAmount}%`};
		}
		.arrow-down {
			&::after {
				content: '';
				position: relative;
				width: 0;
				height: 0;
				border-left: 6px solid transparent;
				border-right: 6px solid transparent;
				border-top: 6px solid #ffffff;
				left: -5px;
			}
		}
		.collateral-infos {
			// text-align: center;
			padding: 8px 2px;
			// color: #000;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			.exchange-name {
				font-size: 18px;
				font-weight: bold;
			}
			.exchange-logo {
				height: 2rem;
				margin-right: 5px;
				width: 2rem;
			}
			.info-text {
				padding: 0 12px;
				border-right: 1px solid #B5B5B5;
				white-space: nowrap;
				&.no-border {
					border-right: 0;
				}
				&.others {
					color: #f28041;
    				display: flex;
				}
			}
			.small-circle {
				height: 10px;
				width: 10px;
				border-radius: 50%;
				background-color: #F28041;
    			margin: 4px;
			}
			.xht-orange-icon {
				width: 21px;
			}
		}
	}
	.member-description-title {
		font-size: 13px;
		font-weight: bold;
	}
	.collateral-member-container {
		position: relative;
		height: 150px;
		.member-content {
			position: absolute;
			.title {
				font-size: 22px;
				font-weight: bold;
			}
		}
		.member-tier-content {
			left: ${(props) => `${props.tierMemberAmount}%`};
		}
		.member-lite-content {
			left: ${(props) => `${props.liteMemberAmount}%`};
		}
		.member-holla-content {
			left: ${(props) => `calc(${props.hollaMemberAmount}% - 195px)`};
			text-align: right;
		}
	}
	.collater-user-cotainer {
		border-top: 1px solid #000;
		padding-right: 180px;
		position: relative;
	}
	.user-area {
		display: flex;
		height: 100%;
		> div {
			flex: 1;
			padding: 22px 10px;
			box-sizing: border-box;
			border-right: 1px solid #000;
			font-size: 24px;
			line-height: 36px;
		}
		.others {
			color: #f00;
		}
		.my {
			color: #4A8DFF;
		}
		.xht-icon {
			width: 35px;
		}
		.blue-circle {
			height: 25px;
			width: 25px;
			border-radius: 50%;
			background-color: #4A8DFF;
			margin-top: 26px;
			padding: 0;
			flex: none;
		}
		.btn-area {
			position: absolute;
			right: 0;
			top: 0;
			box-sizing: border-box;
			padding: 12px 25px;
			width: 180px;
			height: 100%;
			text-align: center;
			.link {
				white-space: nowrap;
				font-size: 12px;
				color: #00f;
				text-decoration: underline;
				cursor: pointer;
			}
		}
		.collater-user-content {
			margin: 1rem 0 2rem 0;
			p:last-child span {
				font-weight: bold;
			}
		}
	}
	.footer-content {
		padding: 1rem 0rem;
		border-top: 1px solid #E5E5E5;
		align-items: flex-start;
		margin-bottom: 2rem;
		.member-description-title {
			padding-bottom: 1rem;
		}
	}
	.block-ui-container {
		padding: 1rem;
		position: relative;
        width: 100%;
        .block-ui-message {
            position: absolute;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			width: 100%;
			top: 8rem;
			z-index: 999;

			.message-icon {
				height: 4rem;
				width: 4rem;
			}
			.message-title-text {
				font-size: 21px;
				font-weight: bold;
			}
			.message-text {
				color: #DADADA;
				font-size: 16px;
				margin: 1rem 0rem;
				text-shadow: 0 0 white;
				text-align: center;
			}
        }
    }
	.blocked-ui {
		text-shadow: 0 0 5px #000000 !important;
		&::before {
            background-color: #000000;
            content: '';
            height: 100%;
            left: 0px;
            opacity: 0.7;
            position: absolute;
            top: 0px;
            width: 100%;
            z-index: 999;
        }
	}
	@media (max-width: 1550px) {
		.collateral-member-container {
			.member-lite-content {
				left: ${(props) => props.liteMemberAmount > 15
		? `${props.liteMemberAmount}%`
		: '15%'
	};
			}
		}
	}
	.table-container {
		margin-bottom: 2rem;
		.ant-table {
			color: #FFFFFF;
		}
		.anchor {
			color: #5985ff;
			text-decoration: underline;
			cursor: pointer;
		}
		.progress-bar {
			height: 15px;
			width: 100%;
			margin: 3px 0px 0px 5px;
			background-color: #C7C7C7;
			.progress-bar-white {
				background-color: #8F8F8D;
			}
		}
		.ant-table-thead > tr > th {
			background-color: #212121;
			color: #FFFFFF;
		}
		.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
			background: #292926;
		}
		.d-flex {
			display: flex;
		}
		.ant-table-placeholder {
			background: #292926;
			.ant-empty-description {
				color: #FFFFFF;
			}
		}
	}
	@media (max-width: 960px) {
		.collater-user-cotainer {
			padding: 0;
		}
		.flex-between {
			align-items: flex-start !important;
		}
		.table-container {
			overflow-x: auto;
		}
		.collateral-member-container {
			.member-content {
				.small-text {
					font-size: 15px !important;
				}
			}
		}
	}
`;

export default Wrapper;
